import * as actions from "./actions";

const initialState = {
	loading: false,
	errors: {}
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.ADD_BENEFIT: {
			return {
				...state,
				loading: true
			};
		}
		case actions.ADD_BENEFIT_SUCCESS: {
			return {
				...state,
				loading: false
			};
		}
		case actions.ADD_BENEFIT_ERROR: {
			return {
				...state,
				errors: payload,
				loading: false
			};
		}

		case actions.ADD_BENEFIT_TO_PROVIDERS: {
			return {
				...state,
				loading: true
			};
		}
		case actions.ADD_BENEFIT_TO_PROVIDERS_SUCCESS: {
			return {
				...state,
				loading: false
			};
		}
		case actions.ADD_BENEFIT_TO_PROVIDERS_ERROR: {
			return {
				...state,
				errors: payload,
				loading: false
			};
		}

		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
